<form [formGroup]="childForm">
  <div class="alerts">
    <page-alert [message]="messageSuccess" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
    <page-alert [message]="messageError" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>
  </div>

  <div class="col-xs-12 col-md-12">
    <div class="col-xs-7 col-md-6">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>CEP</mat-label>
        <input type="text" matInput required formControlName="cep" mask="00000-000" placeholder="CEP" />
      </mat-form-field>
      <mat-error *ngIf="childForm.get('cep')?.hasError('required')  &&  childForm.get('cep')?.touched"> Campo obrigatório </mat-error>
      <mat-error *ngIf="cepError"> Nenhum endereço foi encontrado para este CEP. Verifique se está correto ou tente outro.</mat-error>
      <mat-error *ngIf="childForm.get('cep')?.hasError('pattern')"> Formato Inválido </mat-error>
    </div>
    <div class="col-xs-5 col-md-2">
      <button mat-flat-button color="primary" [disabled]="submittedCep || childForm.get('cep')?.invalid"  (click)="searchAddressByCep()" class="formBt">Buscar</button>
    </div>
  </div>

  <div class="col-xs-12 col-md-12">
    <mat-card>
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <div class="col-xs-12">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>País</mat-label>
              <input
                type="text"
                matInput
                [(ngModel)]="address.country"
                [ngModelOptions]="{ standalone: true }"
                placeholder="País"
                (ngModelChange)="onChangeForm($event)"
                (keypress)="allowOnlyLetters($event)"
              />
            </mat-form-field>
          </div>
          <div class="col-xs-12">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Estado</mat-label>
              <input
                type="text"
                matInput
                [(ngModel)]="address.state"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Estado"
                (ngModelChange)="onChangeForm($event)"
                (keypress)="allowOnlyLetters($event)"
              />
            </mat-form-field>
          </div>
          <div class="col-xs-12">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Cidade</mat-label>
              <input
                type="text"
                matInput
                required
                [(ngModel)]="address.city"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Cidade"
                (ngModelChange)="onChangeForm($event)"
                (keypress)="allowOnlyLetters($event)"
              />
            </mat-form-field>
          </div>
          <div class="col-xs-12">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Logradouro</mat-label>
              <input
                type="text"
                matInput
                required
                [(ngModel)]="address.street"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Cidade"
                (ngModelChange)="onChangeForm($event)"
                (keypress)="allowOnlyLetters($event)"
              />
            </mat-form-field>
          </div>
          <div class="col-xs-12 col-md-6">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Número</mat-label>
              <input
                type="text"
                matInput
                [(ngModel)]="address.number"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Número"
                (ngModelChange)="onChangeForm($event)"
              />
            </mat-form-field>
          </div>
          <div class="col-xs-12 col-md-6">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Complemento</mat-label>
              <input
                type="text"
                matInput
                [(ngModel)]="address.complement"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Complemento"
                (ngModelChange)="onChangeForm($event)"
              />
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-card>

    <div class="col-xs-12 actions">
     
      <button mat-flat-button color="primary" [disabled]="childForm.invalid || cepError  || isSaving"  (click)="save()">
        <ng-container *ngIf="!isSaving">Salvar alterações</ng-container>
        <ng-container *ngIf="isSaving">
          <mat-progress-spinner mode="indeterminate" diameter="20" strokeWidth="3"></mat-progress-spinner>
        </ng-container>
      </button>
    </div>
  </div>
</form>
